import React from "react";
import { Logo } from "@/components/Logo";

export const Footer = () => {
  return (
    <footer className="relative bg-[#0A0A0A] border-t border-white/10 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div>
            <Logo size="sm" />
            <p className="mt-4 text-sm text-[#737373] max-w-md font-light leading-relaxed">
              Servicio profesional de importación de vehículos desde Alemania hasta España.
            </p>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            <a href="#proceso" className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">Proceso</a>
            <a href="#vehiculos" className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">Vehículos</a>
            <a href="#beneficios" className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">Beneficios</a>
            <a href="#contacto" className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">Contacto</a>
          </div>
        </div>
        <div className="gold-line mt-10" />
        <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-[#737373]">© {new Date().getFullYear()} Elecars. Todos los derechos reservados.</p>
          <p className="text-xs text-[#737373]">Importación Alemania → España</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
